var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "c-residence-navigation" },
    [
      _c("list-view-selector"),
      _vm._v(" "),
      _c("div", [_vm._v("\n    Sortering: \n    "), _c("Sorter")], 1),
      _vm._v(" "),
      _c("select-residence-status")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }